import { Injectable } from "@angular/core";
import { Digest } from "./digest.type";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DigestsService {

    constructor(private http: HttpClient){}

    async digests(): Promise<Digest[]> {
        return await firstValueFrom(this.http.get<Digest[]>('/api/digest/config'));
    }

    async createOrUpdate(digest: Digest): Promise<Digest[]>   {
        return await firstValueFrom(this.http.post<Digest[]>('/api/digest/config', digest));
    }

    async test(id: string): Promise<{result: string}> {
        return await firstValueFrom(this.http.get<{result: string}>('/api/digest/config/test/' + id));
    }

    async remove(id: string): Promise<Digest[]> {
        return await firstValueFrom(this.http.delete<Digest[]>('/api/digest/config/' + id));
    }
}